<template lang="pug">
v-expansion-panel.sdo-card(
  dark
).v-expansion-panel--outlined
  v-expansion-panel-header( hide-actions).py-0
    v-list-item(class="handle" style="height: 88px").px-0.mx-0
      transition(name="drag-icon")
        v-list-item-action.mr-4(v-if="editable")
          v-icon(size="28") mdi-drag
      v-list-item-content(
        class="course-unit__title ml-2"
      )
        .text-body-1.card-title {{ unit.title }}
        .caption Уроков - {{unit.lessons.length}}
      v-list-item-action
        v-menu(top)
          template(#activator="{ on }")
            v-btn(
              v-if="editable"
              v-on="on"
              icon
            )
              v-icon mdi-menu
          v-list
            v-list-item(
              :to=`{
                name: 'CourseUnitEdit',
                params: { id: $route.params.id, unitId: unit.id }
              }`
              title="Изменить"
              fab
              depressed
            )
              v-list-item-action
                v-icon(color="secondary") mdi-pencil
              v-list-item-title Редактировать
            v-list-item(
              v-if="canDeleteUnit"
              @click.stop="openDeleteUnitDialog"
              title="Удалить"
              fab
              depressed
              color="white"
            )
              v-list-item-action
                v-icon(color="red darken-2") mdi-delete-outline
              v-list-item-title Удалить

  // Содержимое при раскрытии темы
  v-expansion-panel-content.px-0.mx-n6
    v-row.ma-0
      v-col.pa-0
        v-btn.pr-n5(
          block tile depressed
          :color="tab === 0 ? 'secondary' : ''"
          @click="tab = 0"
        ) Уроки
      v-col.pa-0
        v-btn.pl-n5(
          block tile depressed
          :color="tab === 1 ? 'secondary' : ''"
          @click="tab = 1"
        ) Задания по теме
    v-tabs-items(v-model="tab")
      v-tab-item.pa-4
        unit-lessons-list(
          :lessons="unit.lessons"
          :editable="editable"
          :unitId="unit.id"
          @deleted="$emit('deleted', $event)"
          @change-lesson-order="(val1, val2) => $emit('change-lesson-order', val1, val2)"
          @lesson-tasks="setViewLessonTasks"
          @deleteLesson="$emit('deleteLesson', $event)"
        )
      v-tab-item
        tasks-list(
          :modelId="unit.id"
          :tasks="unit.tasks"
          model="course_units"
        )
      v-tab-item
        .secondary--text.pl-4(
          v-if="selectedLesson"
        ): strong {{ selectedLesson.name }}:
        tasks-list(
          v-if="selectedLesson"
          :modelId="selectedLesson.id"
          :tasks="selectedLesson.tasks"
          model="lessons"
          @detachTask="detachTask"
        )

</template>
<script>
import UnitLessonsList from './UnitLessonsList.vue';
import TasksList from './TasksList.vue';

export default {
  components: {
    UnitLessonsList,
    TasksList,
  },
  props: {
    editable: { type: Boolean, default: true },
    unit: { type: Object, required: true },
    canDeleteUnit: { type: Boolean, default: false },
  },
  data() {
    return {
      tab: 0,
      selectedLesson: null,
    };
  },
  methods: {
    detachTask(taskId) {
      const { selectedLesson } = this;
      selectedLesson.tasks = selectedLesson.tasks.filter(({ id }) => id !== taskId);
    },
    setViewLessonTasks(lesson) {
      this.selectedLesson = lesson;
      this.tab = 2;
    },
    openDeleteUnitDialog() {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.$api.courseUnits.delete(this.unit.id);
          this.$emit('deleted', this.unit);
          this.$modals.close();
        },
      });
    },
  },
};
</script>
